import { type FragmentOf, graphql, readFragment } from "@/graphql"

const MONTHLY_BILLING_FREQUENCY = 1

const graphQLFragments = {
    agreement: graphql(`
        fragment isAgreementMonthlyBillingFrequency_Agreement on AgreementType {
            billingFrequency
        }
    `),
}

type IsAgreementMonthlyBillingFrequencyProps = {
    agreement: FragmentOf<typeof graphQLFragments.agreement>
}

export function isAgreementMonthlyBillingFrequency(props: IsAgreementMonthlyBillingFrequencyProps) {
    const agreement = readFragment(graphQLFragments.agreement, props.agreement)

    return agreement.billingFrequency === MONTHLY_BILLING_FREQUENCY
}

isAgreementMonthlyBillingFrequency.fragments = graphQLFragments
